export default "__VITE_ASSET__rv4DpsWO__"